<template>
    <b-modal id="modal_form"
             ref="modal_form"
             size="lg"
             :title="modal_titulo"
             :ok-title="modal_botao"
             close-title="Fechar"
             cancel-title="Cancelar"
             :ok-disabled=form.errors.any()
             no-close-on-backdrop
             v-model="showModal"
             @ok="handleOk">

        <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
            <b-row no-gutters>
             <b-col>
                 <label>Código</label>
                 <b-form-input type="text"
                               placeholder="Código"
                               v-model="form.cd"
                               name="cd"
                               :disabled = "this.modal_acao == 'u'"
                               >
                 </b-form-input>
                 <b-form-feedback v-text="form.errors.get('cd')" v-if="form.errors.has('cd')"></b-form-feedback>
             </b-col>
             <b-col>
                 <label>Descrição</label>
                 <b-form-input type="text"
                               placeholder="Descrição"
                               v-model="form.descr"
                               name="descr"
                               >
                 </b-form-input>
                 <b-form-feedback v-text="form.errors.get('descr')" v-if="form.errors.has('descr')"></b-form-feedback>
             </b-col>
             <b-col>
                 <label>Aplicação</label>
                 <b-form-input type="text"
                               placeholder="Aplicação"
                               v-model="form.descr_aplicacao"
                               name="descr_aplicacao"
                               >
                 </b-form-input>
                 <b-form-feedback v-text="form.errors.get('descr_aplicacao')" v-if="form.errors.has('descr_aplicacao')"></b-form-feedback>
             </b-col>
           </b-row>
           <b-row no-gutters>
               <b-col md="2" sm="2">
                   <label>Alíquota</label>
                       <currency-input
                          class="form-control"
                          v-model="form.aliquota"
                          :auto-decimal-mode="true"
                          placeholder="Alíquota"
                          :currency="{ prefix: '%'}"
                          :distraction-free="getCurrency"/>
                   <b-form-feedback v-text="form.errors.get('aliquota')" v-if="form.errors.has('aliquota')"></b-form-feedback>
               </b-col>
               <b-col md="2" sm="2">
                   <label>% Redução BC</label>
                       <currency-input
                          class="form-control"
                          v-model="form.perc_red_base_calc"
                          :auto-decimal-mode="true"
                          placeholder="% Redução BC"
                          :currency="{ prefix: '%'}"
                          :distraction-free="getCurrency"/>
                   <b-form-feedback v-text="form.errors.get('perc_red_base_calc')" v-if="form.errors.has('perc_red_base_calc')"></b-form-feedback>
               </b-col>
               <b-col>
                   <label>Situação tributária</label>
                   <multiselect v-model="situacaoTributariaSelected"
                   :options="optionsParamSituacaoTributaria"
                   track-by="value"
                   label="label"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
                   ></multiselect>
                   <b-form-feedback v-text="form.errors.get('parsittri_id')" v-if="form.errors.has('parsittri_id')"></b-form-feedback>
               </b-col>
               <b-col>
                   <label>Tipo Imposto</label>
                   <multiselect v-model="tipoImpostoSelected"
                   :options="optionsParamTipoImposto"
                   track-by="value"
                   label="label"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
                   ></multiselect>
                   <b-form-feedback v-text="form.errors.get('partipimp_id')" v-if="form.errors.has('partipimp_id')"></b-form-feedback>
               </b-col>
               <b-col md="1" sm="1" class="pl-1">
                   <label>Regra</label>
                       <b-form-group>
                         <b-form-radio-group
                           v-model="form.tp_regra"
                           :options="optionsLivTpRegra"
                           name="tp_regra"
                           plain
                           stacked
                           value-field="value"
                         ></b-form-radio-group>
                       </b-form-group>
                   <b-form-feedback v-text="form.errors.get('tp_regra')" v-if="form.errors.has('tp_regra')"></b-form-feedback>
               </b-col>
               <b-col md="1" sm="1">
                   <label>Simples Nacional</label>
                       <b-form-group>
                         <b-form-radio-group
                           v-model="form.simples_nacional"
                           :options="optionsLivSimplesNacional"
                           name="simples_nacional"
                           plain
                           stacked
                           value-field="value"
                         ></b-form-radio-group>
                       </b-form-group>
                   <b-form-feedback v-text="form.errors.get('simples_nacional')" v-if="form.errors.has('simples_nacional')"></b-form-feedback>
               </b-col>
               <b-col md="1" sm="1">
                   <label>Status</label>
                       <b-form-group>
                         <b-form-radio-group
                           v-model="form.status"
                           :options="optionsLivStatus"
                           name="status"
                           plain
                           stacked
                           value-field="value"
                         ></b-form-radio-group>
                       </b-form-group>
                   <b-form-feedback v-text="form.errors.get('status')" v-if="form.errors.has('status')"></b-form-feedback>
               </b-col>
           </b-row>
           <b-row no-gutters>
               <b-col>
                   <label>CST</label>
                   <multiselect v-model="cstSelected"
                   :options="optionsParamCst"
                   track-by="value"
                   label="label"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
                   ></multiselect>
                   <b-form-feedback v-text="form.errors.get('parcst_id')" v-if="form.errors.has('parcst_id')"></b-form-feedback>
               </b-col>
               <b-col>
                   <label>Tipo Documento</label>
                   <multiselect v-model="tipoDocumentoSelected"
                   :options="optionsTpDoc"
                   track-by="value"
                   label="label"
                   :limit="10"
                   :multiple="true"
                   :clear-on-select="false"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
                   ></multiselect>
                   <b-form-feedback v-text="form.errors.get('regra_fiscal_doc')" v-if="form.errors.has('regra_fiscal_doc')"></b-form-feedback>
               </b-col>
               <b-col>
                   <label>Tipo Serviço</label>
                   <multiselect v-model="tipoServicoSelected"
                   :options="optionsTpServico"
                   track-by="value"
                   label="label"
                   :limit="10"
                   :multiple="true"
                   :clear-on-select="false"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
                   ></multiselect>
                   <b-form-feedback v-text="form.errors.get('partpserv_id')" v-if="form.errors.has('partpserv_id')"></b-form-feedback>
               </b-col>
               <b-col>
                   <label>Modal</label>
                   <multiselect v-model="modalSelected"
                   :options="optionsModal"
                   track-by="value"
                   label="label"
                   :limit="10"
                   :multiple="true"
                   :clear-on-select="false"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
                   ></multiselect>
                   <b-form-feedback v-text="form.errors.get('bmodal_id')" v-if="form.errors.has('bmodal_id')"></b-form-feedback>
               </b-col>
               <b-col>
                   <label>NOP</label>
                   <b-form-input type="text"
                                 placeholder="NOP"
                                 v-model="form.nop"
                                 name="nop"
                                 >
                   </b-form-input>
                   <b-form-feedback v-text="form.errors.get('nop')" v-if="form.errors.has('nop')"></b-form-feedback>
               </b-col>
           </b-row>
           <b-row no-gutters>
               <b-col>
                   <label>UF Origem</label>
                   <multiselect v-model="ufOrigemSelected"
                   :options="optionsUf"
                   track-by="value"
                   label="label"
                   :limit="10"
                   :multiple="true"
                   :clear-on-select="false"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
                   ></multiselect>
                   <b-form-feedback v-text="form.errors.get('uf_origem')" v-if="form.errors.has('uf_origem')"></b-form-feedback>
               </b-col>
               <b-col>
                   <label>UF Destino</label>
                   <multiselect v-model="ufDestinoelected"
                   :options="optionsUf"
                   track-by="value"
                   label="label"
                   :limit="10"
                   :multiple="true"
                   :clear-on-select="false"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
                   ></multiselect>
                   <b-form-feedback v-text="form.errors.get('uf_destino')" v-if="form.errors.has('uf_destino')"></b-form-feedback>
               </b-col>
               <b-col>
                   <label>UF Tomador</label>
                   <multiselect v-model="ufTomadorSelected"
                   :options="optionsUf"
                   track-by="value"
                   label="label"
                   :limit="10"
                   :multiple="true"
                   :clear-on-select="false"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
                   ></multiselect>
                   <b-form-feedback v-text="form.errors.get('uf_tomador')" v-if="form.errors.has('uf_tomador')"></b-form-feedback>
               </b-col>
           </b-row>
           <b-row no-gutters>
               <b-col>
                   <label>Observação</label>
                   <b-form-textarea id="textarea"
                                    name="obs"
                                    v-model="form.obs"
                                    placeholder="Observação"
                                    :rows="3"
                                    :max-rows="6">
                   </b-form-textarea>
               </b-col>
           </b-row>
        </form>
        <div slot="modal-footer" class="w-100">
            <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
            <div class="float-right">
                <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
                 <b-btn @click="showModal=false" variant="secondary">
                   Fechar
                 </b-btn>
                 <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                   Enviar
                 </b-btn>
            </div>
        </div>
    </b-modal>
</template>
<script>
import AvisoErros from '../components/AvisoErros'

export default {
components: {
    AvisoErros,
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      statusSelected: [],
      situacaoTributariaSelected: [],
      optionsLivStatus: [],
      optionsLivTpRegra: [],
      optionsLivSimplesNacional: [],
      ufOrigemSelected: [],
      ufDestinoelected: [],
      ufTomadorSelected: [],
      tipoImpostoSelected: [],
      modalSelected: [],
      tipoServicoSelected: [],
      cstSelected: [],
      tipoDocumentoSelected: [],
      optionsParamCst: [],
      optionsParamSituacaoTributaria: [],
      optionsParamTipoImposto: [],
      optionsTpDoc: [],
      optionsUf: [],
      optionsCliente: [],
      optionsModal: [],
      optionsUnidade: [],
      optionsTpServico: [],
      optionsLivIeEst: [],
      optionsLivIndTomador: [],
      optionsLivIndTpCalculo: [],
      optionsLivIndAutomatica: [],
      aliquota: 0,
      perc_red_base_calc: 0,
      regra_fiscal_doc: [],
      bmodal_id: [],
      partpserv_id: [],
      uf_origem: [],
      uf_destino: [],
      uf_tomador: [],
      errors_array: [],
      form: new Form({cd: '',
                      descr: '',
                      descr_aplicacao: '',
                      aliquota: 0,
                      perc_red_base_calc: 0,
                      parsittri_id: '',
                      partipimp_id: '',
                      tp_regra: '',
                      simples_nacional: '',
                      status: '',
                      parcst_id: '',
                      regra_fiscal_doc: [],
                      partpserv_id: [],
                      bmodal_id: [],
                      nop: '',
                      uf_origem: [],
                      uf_destino: [],
                      uf_tomador: [],
                      regfis_id: '',
                      ind_automatica: 1,
                      obs: '',}),
     helpForm: new Form({statusRecord: [], params: []}),
    fields: [],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
watch: {
    tipoServicoSelected(obj) {
        this.partpserv_id = [];
        obj.forEach((item) => {
            this.partpserv_id.push({partpserv_id: item.value, status: 1})
        });
    },
    situacaoTributariaSelected(obj) {
        this.form.parsittri_id = obj.value;
    },
    tipoImpostoSelected(obj) {
        this.form.partipimp_id = obj.value;
    },
    cstSelected(obj) {
        this.form.parcst_id = obj.value;
    },
    tipoDocumentoSelected(obj) {
        this.regra_fiscal_doc = [];
        obj.forEach((item) => {
            this.regra_fiscal_doc.push({status: 1, partipdoc_id: item.value, regfisdoc_id: item.regfisdoc_id})
        });
    },
    modalSelected(obj) {
        this.bmodal_id = [];
        obj.forEach((item) => {
            this.bmodal_id.push({bmodal_id: item.value,regfisufmod_id: item.regfisufmod_id, status: 1})
        });
    },
    ufOrigemSelected(obj) {
        this.uf_origem = [];
        obj.forEach((item) => {
            this.uf_origem.push({uf_id: item.value, regfisufo_id: item.regfisufo_id, status: 1})
        });
    },
    ufDestinoelected(obj) {
        this.uf_destino = [];
        obj.forEach((item) => {
            this.uf_destino.push({uf_id: item.value, regfisufd_id: item.regfisufd_id, status: 1})
        });
    },
    ufTomadorSelected(obj) {
        this.uf_tomador = [];
        obj.forEach((item) => {
            this.uf_tomador.push({uf_id: item.value, regfisuft_id: item.regfisuft_id, status: 1})
        });
    },
},
mounted() {
    this.getLivGeral();
},
created() {
    let self = this;
    Event.$on('editUf', function (data) {
        self.onEdit(data);
    });
},
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.regfis_id);
        }
    },
    onCreate (id)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar Regra Fiscal";
      this.modal_botao = "Cadastrar Regra Fiscal";
      this.modal_acao = "i";
      this.form.reset();
      this.errors_array = '';
      this.errors_array = [];
      this.tipoServicoSelected = [];
      this.situacaoTributariaSelected = [];
      this.tipoImpostoSelected = [];
      this.cstSelected = [];
      this.form.simples_nacional = 2;
      this.form.status = 1; 
      this.form.tp_regra = 1;
      this.tipoDocumentoSelected = [];
      this.modalSelected = [];
      this.ufOrigemSelected = [];
      this.ufDestinoelected = [];
      this.ufTomadorSelected = [];
      this.form.regfis_id = id;
      this.$refs.modal_form.show();
    },
    onEdit (data)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.errors_array = '';
      this.errors_array = [];
      this.tipoServicoSelected = [];
      this.situacaoTributariaSelected = [];
      this.tipoImpostoSelected = [];
      this.cstSelected = [];
      this.tipoDocumentoSelected = [];
      this.modalSelected = [];
      this.ufOrigemSelected = [];
      this.ufDestinoelected = [];
      this.ufTomadorSelected = [];
      this.form.cd = data.cd;
      this.form.descr = data.descr;
      this.form.obs = data.obs;
      this.form.aliquota = data.aliquota;
      this.form.perc_red_base_calc = data.perc_red_base_calc;
      this.form.descr_aplicacao = data.descr_aplicacao;
      this.form.nop = data.nop;
      this.form.status = data.status.valor;
      this.form.simples_nacional = data.simples_nacional.valor;
      this.form.tp_regra = data.tp_regra.valor;
      this.situacaoTributariaSelected = { label: data.param_situacao_tributaria.descr, value: data.param_situacao_tributaria.parsittri_id };
      this.tipoImpostoSelected= { label: data.param_tipo_imposto.descr, value: data.param_tipo_imposto.partipimp_id };
      this.cstSelected = { label: data.param_cst.descr, value: data.param_cst.parcst_id };
      data.regra_fiscal_doc.forEach((item) => {
          if(item.status.valor==1)
          {
              this.tipoDocumentoSelected.push({label: item.param_tipo_doc.descr, value: item.partipdoc_id, regfisdoc_id: item.regfisdoc_id, });
          }
      })
      data.regra_fiscal_modal.forEach((item) => {
          if(item.status.valor==1)
          {
              this.modalSelected.push({label: item.b_modal.descr, value: item.bmodal_id, regfismod_id: item.regfigmod_id});
          }
      })
      data.regra_fiscal_uf_origem.forEach((item) => {
          if(item.status.valor==1)
          {
              this.ufOrigemSelected.push({label: item.uf.nome, value: item.uf_id, regfisufo_id: item.regfisufo_id});
          }
      })
      data.regra_fiscal_uf_destino.forEach((item) => {
          if(item.status != null && item.status.valor==1)
          {
              this.ufDestinoelected.push({label: item.uf.nome, value: item.uf_id, regfisufd_id: item.regfisufd_id});
          }
      })
      data.regra_fiscal_tp_servico.forEach((item) => {
          if(item.status != null && item.status.valor==1)
          {
              this.tipoServicoSelected.push({label: item.param_tipo_servico.descr, value: item.partpserv_id, regfistpserv_id: item.regfistpserv_id});
          }
      })
      data.regra_fiscal_uf_tomador.forEach((item) => {
          if(item.status.valor==1)
          {
              this.ufTomadorSelected.push({label: item.uf.nome, value: item.uf_id, regfisuft_id: item.regfisuft_id});
          }
      })
      this.form.regfis_id = data.regfis_id;
      this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.regra_fiscal_doc = this.regra_fiscal_doc;
        this.form.bmodal_id = this.bmodal_id;
        this.form.partpserv_id = this.partpserv_id;
        this.form.uf_destino = this.uf_destino;
        this.form.uf_origem = this.uf_origem;
        this.form.uf_tomador = this.uf_tomador;
        this.form.ind_automatica = 1;
        this.form.put('/api/'+this.rota+'/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.$parent.$refs.vuetable.reload();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.regra_fiscal_doc = this.regra_fiscal_doc;
        this.form.bmodal_id = this.bmodal_id;
        this.form.partpserv_id = this.partpserv_id;
        this.form.uf_destino = this.uf_destino;
        this.form.uf_origem = this.uf_origem;
        this.form.ind_automatica = 1;
        this.form.uf_tomador = this.uf_tomador;
        this.form.patch('/api/'+this.rota+'/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.$parent.$refs.vuetable.reload();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onActivateDesactivate(helpForm)
    {
        helpForm.patch('/api/'+this.rota+'/status').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.$parent.$refs.vuetable.reload();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });

    },
    getLivGeral()
    {
        this.helpForm.get('/api/regrafiscal/jsonlistgeral').then(response =>
        {
            new ReturnApi(response, this, true, false, false);
            response.status.forEach((obj)=>
            {
                this.optionsLivStatus.push({ text: obj.descr, value: obj.valor })
            })
            response.simples_nacional.forEach((obj)=>
            {
                this.optionsLivSimplesNacional.push({ text: obj.descr, value: obj.valor })
            })
            response.tp_regra.forEach((obj)=>
            {
                this.optionsLivTpRegra.push({ text: obj.descr, value: obj.valor })
            })
            response.cst.forEach((obj)=>
            {
                this.optionsParamCst.push({ label: obj.cd+" - "+obj.descr, value: obj.parcst_id })
            })
            response.tp_imposto.forEach((obj)=>
            {
                this.optionsParamTipoImposto.push({ label: obj.descr, value: obj.partipimp_id })
            })
            response.situacao_tributaria.forEach((obj)=>
            {
                this.optionsParamSituacaoTributaria.push({ label: obj.descr, value: obj.parsittri_id })
            })
            response.tp_doc.forEach((obj)=>
            {
                this.optionsTpDoc.push({ label: obj.descr, value: obj.partipdoc_id, regfisdoc_id: obj.regfisdoc_id })
            })
            response.uf.forEach((obj)=>
            {
                this.optionsUf.push({ label: obj.nome, value: obj.uf_id })
            })
            response.modal.forEach((obj)=>
            {
                this.optionsModal.push({ label: obj.descr, value: obj.bmodal_id })
            })
            response.unidade.forEach((obj)=>
            {
                this.optionsUnidade.push({ label: obj.descr, value: obj.unidade_id })
            })
            response.tp_servico.forEach((obj)=>
            {
                this.optionsTpServico.push({ label: obj.descr, value: obj.partpserv_id })
            })
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    getCurrency: {
        get() {
            return this.$store.getters.currency;
        }
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
